import { makeStyles, Text } from '@rneui/themed'
import { t } from 'app/i18l'
import { font } from 'app/theme'
import React from 'react'

interface Props {
  isWorkedShift?: boolean
}

export function PastShiftStatusView(props: Props) {
  const styles = useStyles(props.isWorkedShift)

  return (
    <Text style={styles.container} numberOfLines={1}>
      {props.isWorkedShift ? t('workedShift') : t('didNotWorkShift')}
    </Text>
  )
}

export const PAST_SHIFT_STATUS_HEIGHT = 20

const useStyles = makeStyles((theme, isWorkedShift?: boolean) => ({
  container: {
    height: PAST_SHIFT_STATUS_HEIGHT,
    fontSize: 15,
    fontFamily: font.bold,
    color: isWorkedShift ? theme.colors?.grey1 : theme.colors?.primary,
    textAlign: 'center',
  },
}))
